import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "FormatsByType";
var classes = {
    type: "".concat(PREFIX, "-type"),
    details: "".concat(PREFIX, "-details"),
    formats: "".concat(PREFIX, "-formats"),
    formatsOpen: "".concat(PREFIX, "-formatsOpen"),
    filters: "".concat(PREFIX, "-filters"),
    addMore: "".concat(PREFIX, "-addMore"),
    addMoreContainer: "".concat(PREFIX, "-addMoreContainer"),
    searchContainer: "".concat(PREFIX, "-searchContainer")
};
var StyledFormatsByType = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginBottom: theme.spacing(1)
        },
        _b["& .".concat(classes.type)] = {
            margin: theme.spacing(1, 0)
        },
        _b["& .".concat(classes.details)] = {
            padding: 0,
            display: "flex",
            flexDirection: "column"
        },
        _b["& .".concat(classes.formats)] = {
            display: "grid",
            padding: 0,
            gap: theme.spacing(1),
            alignItems: "stretch",
            justifyContent: "flex-start",
            gridTemplateColumns: "repeat(auto-fill, ".concat(theme.spacing(17), ")"),
            listStyle: "none",
            margin: 0,
            gridAutoFlow: "column"
        },
        _b["& .".concat(classes.formatsOpen)] = {
            gridAutoFlow: "unset"
        },
        _b["& .".concat(classes.filters)] = {
            marginBottom: theme.spacing(1)
        },
        _b["& .".concat(classes.addMore)] = {
            padding: theme.spacing(1),
            display: "flex",
            alignItems: "flex-end",
            minHeight: "100%",
            textAlign: "left",
            lineHeight: 1.2,
            textDecoration: "underline"
        },
        _b["& .".concat(classes.addMoreContainer)] = {
            display: "flex",
            width: theme.spacing(17),
            borderRadius: theme.shape.borderRadius
        },
        _b);
});

export { classes, StyledFormatsByType as default };
//# sourceMappingURL=index.styled.js.map
